import React from 'react'
import PropTypes from 'prop-types'
import { UncontrolledTooltip } from 'reactstrap'

function renderLegend(id, dictionary, keys) {
  return (
    <UncontrolledTooltip key={id} placement="right" target={id}>
      <ul className="list-unstyled">
        {keys.map(key => {
          const dimensionFromDict = dictionary.find(o => o.name === key) || {}
          return <li key={key}>{key} - {key && dimensionFromDict.description}</li>
        })}
      </ul>
    </UncontrolledTooltip>)
}

const propTypes = {
  dimensionsDictionary: PropTypes.array.isRequired,
  certificate: PropTypes.object.isRequired,
  tdClassName: PropTypes.string,
}

const CertificateDimensions = ({ tdClassName, dimensionsDictionary, certificate }) => {
  const sId = `dimension_s_${certificate.id}${tdClassName}`
  const tId = `dimension_t_${certificate.id}${tdClassName}`
  const dId = `dimension_d_${certificate.id}${tdClassName}`
  const dimensions = certificate.dimensions || {}
  const valS = certificate.dimension_s || dimensions['s']
  const valT = certificate.dimension_t || dimensions['t']
  const valD = certificate.dimension_d || dimensions['D']

  return (
    <React.Fragment>
      <td key={sId} className={tdClassName}>
        <div id={sId}>
          {valS && [`s ${valS}`, renderLegend(sId, dimensionsDictionary, ['s'])]}
        </div>
        <br />
        <div id={tId}>
          {valT && [`t ${valT}`, renderLegend(tId, dimensionsDictionary, ['t'])]}
        </div>
      </td>
      <td key={dId} className={tdClassName} id={dId}>
        {valD && [`D ${valD}`, renderLegend(dId, dimensionsDictionary, ['D'])]}
      </td>
    </React.Fragment>
  )
}

CertificateDimensions.propTypes = propTypes

export default CertificateDimensions



// WEBPACK FOOTER //
// ./src/components/Welders/helpers/CertificateDimensions.js